import { Injectable, inject } from '@angular/core'
import { BndSnackbarRef, BndSnackbarService, BndSnackbarType } from '@bonduelle-it/storybook'

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly snackbarService = inject(BndSnackbarService)

  private showToast(message: string, type: BndSnackbarType, duration: number): BndSnackbarRef {
    return this.snackbarService.open({
      type,
      title: message,
      duration,
    })
  }

  public showToastWarning(message: string, duration: number = 3000): BndSnackbarRef {
    return this.showToast(message, 'warning', duration)
  }

  public showToastInfo(message: string, duration: number = 3000): BndSnackbarRef {
    return this.showToast(message, 'info', duration)
  }

  public showToastError(message: string, duration: number = 3000): BndSnackbarRef {
    return this.showToast(message, 'error', duration)
  }

  public showToastSuccess(message: string, duration: number = 3000): BndSnackbarRef {
    return this.showToast(message, 'success', duration)
  }
}
